import { render, staticRenderFns } from "./CommunityCollage.vue?vue&type=template&id=71493d74&scoped=true"
import script from "./CommunityCollage.vue?vue&type=script&lang=js"
export * from "./CommunityCollage.vue?vue&type=script&lang=js"
import style0 from "./CommunityCollage.vue?vue&type=style&index=0&id=71493d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71493d74",
  null
  
)

export default component.exports